export const registryThemes = [
  { value: "foundry-light", label: "Foundry light" },
  { value: "foundry-dark", label: "Foundry dark" },
  { value: "lancer-dark", label: "Lancer dark" },
  { value: "troika-dark", label: "Troika dark" },
  { value: "generic-light", label: "Generic light" },
  { value: "generic-dark", label: "Generic dark" },
] as const;

export type RegistryTheme = (typeof registryThemes)[number]["value"];
